"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AnyCondition {
    // @ts-ignore
    // noinspection JSUnusedLocalSymbols
    isFulfilled(value) {
        return { fulfilled: true };
    }
    setOptions(options) {
        this.options = options;
    }
}
exports.AnyCondition = AnyCondition;
//# sourceMappingURL=AnyCondition.js.map